import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from "@angular/core";

@Component({
  selector: "app-shared-logo",
  templateUrl: "logo.component.html",
  styleUrl: "logo.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class LogoComponent {
  private initialFullWidth: number = 165;

  private initialIconWidth: number = 25.86;

  public isFullSize: InputSignal<boolean> = input<boolean>(true);

  public width: InputSignal<number> = input<number>(this.initialFullWidth);

  public computedWidth: Signal<number> = computed(() => (this.isFullSize() ? this.width() : this.initialIconWidth * this.widthFactor()));

  private widthFactor: Signal<number> = computed(() => this.width() / this.initialFullWidth);

  public viewBox: Signal<string> = computed(() => (this.isFullSize() ? "0 0 165 29" : "0 0 25.86 29"));
}
